import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION } from '../../../../constants/common'
import { RENTAL_APPLICANT_DOCUMENTS_ENTITY } from '../../../../constants/entity'
import { FILE_SCOPE_RENTAL_APPLICANT } from '../../../../constants/file'
import {
  getDocumentsItemActions,
  getDocumentsMassActions,
} from '../../../Document'
import { EntityTabDocuments } from '../../../EntityTab'
import { PageEmptyState } from '../../../PageEmptyState'
import { useApplicantProfileContext } from '../RentalPortalApplicantProfile.hooks'

import {
  APPLICANT_PROFILE_DOCUMENTS_BREADCRUMB_APPLICANT,
  QA_NAME_APPLICANT_PROFILE_DOCUMENTS_FOLDER,
} from './RentalPortalApplicantProfileDocuments.constants'
import {
  getApplicantDocumentsFolderEmptyKey,
  getApplicantDocumentsRootBreadcrumbs,
  getIsApplicantDocumentsFolderAvailable,
} from './RentalPortalApplicantProfileDocuments.utils'

import DocumentIcon from '../../../../icons/document.svg'

function RentalPortalApplicantProfileDocuments() {
  const { t } = useTranslation()

  const { applicantData, handleEntityReload } = useApplicantProfileContext()

  return getIsApplicantDocumentsFolderAvailable(applicantData) ? (
    <EntityTabDocuments
      breadcrumbRootItems={getApplicantDocumentsRootBreadcrumbs({
        applicantData,
        t,
      })}
      breadcrumbStorageItemId={APPLICANT_PROFILE_DOCUMENTS_BREADCRUMB_APPLICANT}
      entity={RENTAL_APPLICANT_DOCUMENTS_ENTITY}
      // TODO: drop once the backend rental-portal branch is merged: qa has no rental_applicant scope and a scoped download returns 500.
      getDownloadApiParams={EMPTY_FUNCTION}
      getItemActions={getDocumentsItemActions}
      getMassActions={getDocumentsMassActions}
      objectId={applicantData?.id}
      qaNameTable={QA_NAME_APPLICANT_PROFILE_DOCUMENTS_FOLDER}
      rootDirectoryId={applicantData?.directory_id}
      scope={FILE_SCOPE_RENTAL_APPLICANT}
      onLoadCounters={handleEntityReload}
    />
  ) : (
    <PageEmptyState
      EntityIcon={DocumentIcon}
      text={t(getApplicantDocumentsFolderEmptyKey(applicantData))}
    />
  )
}

export default RentalPortalApplicantProfileDocuments
